module.exports = __webpack_public_path__ + "img/bg1.216e5db4.png";